exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/oneills-web-qa/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main